import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[70svh] flex-col items-center justify-center px-5 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.35em] text-signal">404 — Off trail</p>
      <h1 className="mt-4 font-display text-5xl font-bold uppercase tracking-tighter sm:text-6xl">
        Wrong path.
      </h1>
      <p className="mt-4 max-w-sm text-sm text-muted-foreground">
        This page doesn't exist — but your path does. Head back and keep moving.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 border border-foreground px-8 py-3.5 font-mono text-xs uppercase tracking-[0.25em] transition-colors hover:bg-foreground hover:text-background"
      >
        Back home
      </Link>
    </div>
  );
}
